import { render } from "./EditLiveData.vue?vue&type=template&id=5da310e8"
import script from "./EditLiveData.vue?vue&type=script&lang=js"
export * from "./EditLiveData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__